module.exports = __webpack_public_path__ + "img/noAddress.6a2162b0.png";